// // components/Admin/Quotation.js
// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import html2canvas from 'html2canvas';
// import { jsPDF } from 'jspdf';

// const Quotation = () => {
//   const navigate = useNavigate();
//   const [quotationItemCount, setQuotationItemCount] = useState(1);
//   const [featureCount, setFeatureCount] = useState(1);
//   const [showPreview, setShowPreview] = useState(false);
//   const [formData, setFormData] = useState({
//     quotationNumber: 'QT-BSE-001',
//     quotationDate: new Date().toISOString().split('T')[0],
//     validUntil: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
//     clientName: '',
//     clientAddress: '',
//     projectName: '',
//     projectDescription: '',
//     timelineDays: '',
//     timelineMonths: '',
//     advancePercentage: '50',
//     totalAmount: '0',
//     features: [''],
//     items: [
//       {
//         feature: '',
//         description: '',
//         amount: '0'
//       }
//     ]
//   });

//   const previewRef = useRef(null);
//   const [pdfError, setPdfError] = useState(null);

//   // Blue Sky Energy theme colors
//   const theme = {
//     primary: '#447793',
//     secondary: '#2D5A74',
//     dark: '#123249',
//     light: '#DDE8ED',
//     white: '#ffffff',
//     text: '#123249'
//   };

//   // Styles
//   const styles = {
//     container: {
//       fontFamily: "'Cambria', 'Segoe UI', serif",
//       backgroundColor: '#f5f7fa',
//       minHeight: '100vh',
//       color: theme.text,
//       display: 'flex',
//       flexDirection: 'column',
//       padding: '20px',
//       boxSizing: 'border-box'
//     },
//     header: {
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       marginBottom: '30px',
//       paddingBottom: '15px',
//       borderBottom: `2px solid ${theme.primary}`,
//       flexWrap: 'wrap',
//       gap: '15px'
//     },
//     headerTitle: {
//       fontSize: 'clamp(1.2rem, 4vw, 2rem)',
//       color: theme.dark,
//       fontWeight: 600,
//       margin: 0
//     },
//     headerActions: {
//       display: 'flex',
//       gap: '10px',
//       flexWrap: 'wrap'
//     },
//     btn: {
//       padding: '10px 20px',
//       border: 'none',
//       borderRadius: '5px',
//       cursor: 'pointer',
//       fontSize: '14px',
//       fontWeight: 500,
//       transition: 'all 0.3s ease',
//       textDecoration: 'none',
//       display: 'inline-flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       gap: '8px',
//       width: 'auto'
//     },
//     btnOutlinePrimary: {
//       background: 'transparent',
//       border: `1px solid ${theme.primary}`,
//       color: theme.primary
//     },
//     btnPrimary: {
//       background: theme.primary,
//       color: 'white'
//     },
//     btnSuccess: {
//       background: theme.secondary,
//       color: 'white'
//     },
//     btnDanger: {
//       background: '#e74c3c',
//       color: 'white'
//     },
//     btnOutlineDanger: {
//       background: 'transparent',
//       border: '1px solid #e74c3c',
//       color: '#e74c3c'
//     },
//     btnSm: {
//       padding: '6px 12px',
//       fontSize: '12px'
//     },
//     quotationContainer: {
//       background: 'white',
//       borderRadius: '10px',
//       padding: '30px',
//       boxShadow: '0 4px 12px rgba(6,18,33,0.1)',
//       marginBottom: '30px'
//     },
//     formGroup: {
//       marginBottom: '20px'
//     },
//     label: {
//       display: 'block',
//       marginBottom: '8px',
//       fontWeight: 500,
//       color: theme.dark
//     },
//     input: {
//       width: '100%',
//       padding: '12px 15px',
//       border: `1px solid ${theme.light}`,
//       borderRadius: '5px',
//       fontSize: '14px',
//       transition: 'border-color 0.3s ease',
//       outline: 'none',
//       boxSizing: 'border-box'
//     },
//     textarea: {
//       width: '100%',
//       padding: '12px 15px',
//       border: `1px solid ${theme.light}`,
//       borderRadius: '5px',
//       fontSize: '14px',
//       transition: 'border-color 0.3s ease',
//       outline: 'none',
//       resize: 'vertical',
//       minHeight: '80px',
//       boxSizing: 'border-box'
//     },
//     grid2: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
//       gap: '20px',
//       marginBottom: '20px'
//     },
//     tableResponsive: {
//       overflowX: 'auto',
//       marginBottom: '20px',
//       WebkitOverflowScrolling: 'touch',
//       border: `1px solid ${theme.light}`,
//       borderRadius: '5px'
//     },
//     table: {
//       width: '100%',
//       borderCollapse: 'collapse',
//       minWidth: '600px'
//     },
//     th: {
//       padding: '12px 15px',
//       textAlign: 'left',
//       borderBottom: `1px solid ${theme.light}`,
//       fontWeight: 600,
//       color: theme.dark,
//       fontSize: '14px',
//       backgroundColor: theme.light,
//       whiteSpace: 'nowrap'
//     },
//     td: {
//       padding: '12px 15px',
//       borderBottom: `1px solid ${theme.light}`
//     },
//     inputSm: {
//       width: '100%',
//       padding: '8px 10px',
//       border: `1px solid ${theme.light}`,
//       borderRadius: '4px',
//       fontSize: '13px',
//       outline: 'none',
//       boxSizing: 'border-box'
//     },
//     inputGroup: {
//       display: 'flex',
//       gap: '10px',
//       marginBottom: '10px',
//       flexWrap: 'wrap'
//     },
//     textCenter: {
//       textAlign: 'center'
//     },
//     mb3: {
//       marginBottom: '15px'
//     },
//     mb4: {
//       marginBottom: '20px'
//     },
//     hidden: {
//       display: 'none'
//     },
//     quotationPreview: {
//       border: `1px solid ${theme.light}`,
//       padding: '20px',
//       backgroundColor: 'white',
//       marginTop: '20px',
//       borderRadius: '10px',
//       overflowX: 'auto'
//     },
//     mobileNote: {
//       display: 'none',
//       textAlign: 'center',
//       color: theme.secondary,
//       fontSize: '12px',
//       marginBottom: '10px'
//     },
//     actionButtons: {
//       display: 'flex',
//       gap: '10px',
//       flexWrap: 'wrap',
//       justifyContent: 'center'
//     },
//     errorMessage: {
//       backgroundColor: '#fee',
//       color: '#c00',
//       padding: '10px',
//       borderRadius: '5px',
//       marginBottom: '20px',
//       textAlign: 'center'
//     }
//   };

//   // Set today's date as default
//   useEffect(() => {
//     const today = new Date();
//     const formattedDate = today.toISOString().split('T')[0];

//     const validUntil = new Date();
//     validUntil.setDate(today.getDate() + 30);
//     const formattedValidUntil = validUntil.toISOString().split('T')[0];

//     setFormData(prev => ({
//       ...prev,
//       quotationDate: formattedDate,
//       validUntil: formattedValidUntil
//     }));
//   }, []);

//   const handleInputChange = (e) => {
//     const { id, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [id]: value
//     }));
//   };

//   const addFeature = () => {
//     setFormData(prev => ({
//       ...prev,
//       features: [...prev.features, '']
//     }));
//     setFeatureCount(prev => prev + 1);
//   };

//   const removeFeature = (index) => {
//     if (formData.features.length > 1) {
//       const updatedFeatures = formData.features.filter((_, i) => i !== index);
//       setFormData(prev => ({
//         ...prev,
//         features: updatedFeatures
//       }));
//       setFeatureCount(prev => prev - 1);
//     }
//   };

//   const handleFeatureChange = (index, value) => {
//     const updatedFeatures = [...formData.features];
//     updatedFeatures[index] = value;
//     setFormData(prev => ({
//       ...prev,
//       features: updatedFeatures
//     }));
//   };

//   const addQuotationItem = () => {
//     const newItem = {
//       feature: '',
//       description: '',
//       amount: '0'
//     };
    
//     setFormData(prev => ({
//       ...prev,
//       items: [...prev.items, newItem]
//     }));
//     setQuotationItemCount(prev => prev + 1);
//   };

//   const removeQuotationItem = (index) => {
//     if (formData.items.length > 1) {
//       const updatedItems = formData.items.filter((_, i) => i !== index);
//       setFormData(prev => ({
//         ...prev,
//         items: updatedItems
//       }));
//       setQuotationItemCount(prev => prev - 1);
//       calculateQuotationTotal(updatedItems);
//     } else {
//       alert("You need at least one item in the quotation.");
//     }
//   };

//   const handleQuotationItemChange = (index, field, value) => {
//     const updatedItems = [...formData.items];
//     updatedItems[index][field] = value;
    
//     setFormData(prev => ({
//       ...prev,
//       items: updatedItems
//     }));
    
//     calculateQuotationTotal(updatedItems);
//   };

//   const calculateQuotationTotal = (items) => {
//     let total = 0;
    
//     items.forEach(item => {
//       const amount = parseFloat(item.amount) || 0;
//       total += amount;
//     });
    
//     setFormData(prev => ({
//       ...prev,
//       totalAmount: total.toFixed(2)
//     }));
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return '';
//     const date = new Date(dateString);
//     const day = date.getDate().toString().padStart(2, '0');
//     const month = (date.getMonth() + 1).toString().padStart(2, '0');
//     const year = date.getFullYear();
//     return `${day}/${month}/${year}`;
//   };

//   const generateQuotationHTML = () => {
//     let featuresHTML = '';
//     formData.features.forEach(feature => {
//       if (feature.trim() !== '') {
//         featuresHTML += `<li style="color: #2D5A74; margin-bottom: 3px;">${feature}</li>`;
//       }
//     });

//     // Add placeholder features if none provided
//     if (featuresHTML === '') {
//       featuresHTML = `
//         <li><span style="border-bottom: 1px dashed #447793; display: inline-block; width: 90%;"></span></li>
//         <li><span style="border-bottom: 1px dashed #447793; display: inline-block; width: 80%;"></span></li>
//         <li><span style="border-bottom: 1px dashed #447793; display: inline-block; width: 70%;"></span></li>
//       `;
//     }

//     let itemsHTML = '';
//     formData.items.forEach((item, index) => {
//       itemsHTML += `
//         <tr>
//           <td style="border: 1px solid #DDE8ED; padding: 8px 5px; text-align: left;">${item.feature}</td>
//           <td style="border: 1px solid #DDE8ED; padding: 8px 5px; text-align: left;">${item.description}</td>
//           <td style="border: 1px solid #DDE8ED; padding: 8px 5px; text-align: right;">₹${parseFloat(item.amount).toFixed(2)}</td>
//         </tr>
//       `;
//     });

//     // Add empty rows to match layout (5 total rows)
//     const MIN_ROWS = 5;
//     const emptyRowCount = Math.max(0, MIN_ROWS - formData.items.length);
//     for (let i = 0; i < emptyRowCount; i++) {
//       itemsHTML += `<tr><td style="border: 1px solid #DDE8ED; padding: 8px 5px;"></td><td style="border: 1px solid #DDE8ED; padding: 8px 5px;"></td><td style="border: 1px solid #DDE8ED; padding: 8px 5px; text-align: right;"></td></tr>`;
//     }

//     return `
//       <div id="quotation-pdf-content" style="width: 100%; max-width: 800px; margin: 0 auto; background: white; font-family: 'Cambria', serif; padding: 20px; box-sizing: border-box;">
//         <!-- Page 1 -->
//         <div style="margin-bottom: 30px; page-break-after: always;">
//           <!-- Header -->
//           <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 20px; border-bottom: 2px solid #447793; padding-bottom: 15px; flex-wrap: wrap;">
//             <div style="display: flex; align-items: center; gap: 10px;">
//               <div style="width: 40px; height: 40px; background: linear-gradient(135deg, #447793, #2D5A74); border-radius: 5px; display: flex; align-items: center; justify-content: center; color: white; font-size: 20px;">☀️</div>
//               <div>
//                 <h2 style="font-size: 18px; font-weight: bold; margin: 0; color: #123249;">Blue Sky Energy</h2>
//                 <p style="font-size: 10px; color: #2D5A74; margin: 2px 0 0;">Powering a Greener Tomorrow</p>
//               </div>
//             </div>
//             <div style="text-align: right;">
//               <p style="font-size: 14px; font-weight: bold; color: #447793; margin: 0 0 5px;">${formData.quotationNumber}</p>
//               <p style="font-size: 11px; color: #123249; margin: 2px 0;">Date: ${formatDate(formData.quotationDate)}</p>
//               <p style="font-size: 11px; color: #123249; margin: 2px 0;">Valid Until: ${formatDate(formData.validUntil)}</p>
//             </div>
//           </div>

//           <!-- Recipient Info -->
//           <div style="margin-bottom: 20px; padding: 15px; background-color: #DDE8ED; border-radius: 5px;">
//             <p style="margin: 5px 0; color: #123249;"><strong>To:</strong> <span style="border-bottom: 1px dashed #447793; display: inline-block; margin-left: 5px; min-width: 200px; color: #2D5A74;">${formData.clientName}</span></p>
//             <p style="margin: 5px 0; color: #123249;"><strong>Address:</strong> <span style="border-bottom: 1px dashed #447793; display: inline-block; margin-left: 5px; min-width: 300px; color: #2D5A74;">${formData.clientAddress}</span></p>
//           </div>

//           <!-- Project Details -->
//           <div style="margin-bottom: 20px;">
//             <h2 style="color: #447793; font-size: 16px; border-bottom: 2px solid #447793; padding-bottom: 5px; display: inline-block; margin-bottom: 10px;">Project: ${formData.projectName}</h2>
//             <p style="color: #123249; font-weight: bold; margin: 10px 0 5px;">Project Features:</p>
//             <ul style="list-style-type: disc; margin: 10px 0 20px 20px; padding: 0; line-height: 1.5; color: #2D5A74;">
//               ${featuresHTML}
//             </ul>
//           </div>

//           <!-- Pricing Table -->
//           <div style="overflow-x: auto; margin-bottom: 20px;">
//             <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
//               <thead>
//                 <tr>
//                   <th style="border: 1px solid #DDE8ED; padding: 10px 5px; text-align: left; background-color: #DDE8ED; color: #123249; font-weight: bold;">Feature</th>
//                   <th style="border: 1px solid #DDE8ED; padding: 10px 5px; text-align: left; background-color: #DDE8ED; color: #123249; font-weight: bold;">Description</th>
//                   <th style="border: 1px solid #DDE8ED; padding: 10px 5px; text-align: right; background-color: #DDE8ED; color: #123249; font-weight: bold;">Amount (₹)</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 ${itemsHTML}
//                 <tr style="background-color: #DDE8ED; font-weight: bold;">
//                   <td colspan="2" style="border: 1px solid #DDE8ED; padding: 10px 5px; text-align: left;">Total Amount</td>
//                   <td style="border: 1px solid #DDE8ED; padding: 10px 5px; text-align: right;">₹${parseFloat(formData.totalAmount).toFixed(2)}</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>

//           <!-- Additional Info -->
//           <div style="padding: 15px; background-color: #DDE8ED; border-radius: 5px;">
//             <p style="margin: 5px 0; color: #123249;"><strong>Payment Terms:</strong> ${formData.advancePercentage}% advance payment required</p>
//             <p style="margin: 5px 0; color: #123249;"><strong>Timeline:</strong> ${formData.timelineDays || '—'} days / ${formData.timelineMonths || '—'} months</p>
//           </div>
//         </div>
        
//         <!-- Page 2 - Terms and Conditions with Scanner Box -->
//         <div style="page-break-before: always; margin-top: 30px;">
//           <!-- Header -->
//           <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 20px; border-bottom: 1px solid #DDE8ED; padding-bottom: 10px;">
//             <div style="width: 30px; height: 30px; background: linear-gradient(135deg, #447793, #2D5A74); border-radius: 5px; display: flex; align-items: center; justify-content: center; color: white; font-size: 14px;">☀️</div>
//             <span style="font-size: 14px; font-weight: bold; color: #123249;">Blue Sky Energy</span>
//             <span style="margin-left: auto; font-size: 11px; color: #447793;">${formData.quotationNumber}</span>
//           </div>
          
//           <!-- Terms and Conditions -->
//           <div style="margin-bottom: 20px;">
//             <h3 style="font-size: 16px; color: #123249; border-bottom: 2px solid #447793; padding-bottom: 5px; margin-bottom: 15px;">Terms & Conditions</h3>
//             <ol style="list-style-type: decimal; padding-left: 20px; line-height: 1.6; color: #2D5A74;">
//               <li style="margin-bottom: 10px;">
//                 Timeline: <span style="border-bottom: 1px dashed #447793; display: inline-block; min-width: 40px; text-align: center; color: #123249;">${formData.timelineDays || '—'}</span> days / <span style="border-bottom: 1px dashed #447793; display: inline-block; min-width: 40px; text-align: center; color: #123249;">${formData.timelineMonths || '—'}</span> months from confirmation.
//                 <span style="display: block; margin-top: 3px; font-style: italic; color: #e67e22;">*Urgent work may incur extra charges*</span>
//               </li>
//               <li style="margin-bottom: 10px;">
//                 <span style="border-bottom: 1px dashed #447793; display: inline-block; min-width: 40px; text-align: center; color: #123249;">${formData.advancePercentage}</span>% advance payment required to initiate project.
//               </li>
//               <li style="margin-bottom: 10px;">
//                 Additional features/modifications beyond scope may incur extra charges.
//               </li>
//               <li style="margin-bottom: 10px;">
//                 Hardware replacement costs may apply if components fail during testing/demonstration.
//               </li>
//               <li style="margin-bottom: 10px;">
//                 Equipment warranty as per manufacturer. Labor warranty: 90 days from installation.
//               </li>
//               <li style="margin-bottom: 10px;">
//                 Quotation valid for 30 days. Prices subject to change after validity.
//               </li>
//             </ol>
//           </div>

//           <!-- Declaration and Scanner Box - Split into Half -->
//           <div style="display: flex; gap: 20px; margin-bottom: 20px; flex-wrap: wrap;">
//             <!-- Declaration Section - Left Half -->
//             <div style="flex: 1; min-width: 250px;">
//               <div style="padding: 15px; background-color: #DDE8ED; border-radius: 5px; height: 100%; box-sizing: border-box;">
//                 <p style="margin: 0; color: #123249; font-style: italic;">
//                   <strong>Declaration:</strong> This quotation reflects true prices and all particulars are true and correct.
//                 </p>
//               </div>
//             </div>
            
//             <!-- Scanner Box Section - Right Half -->
//             <div style="flex: 1; min-width: 200px; display: flex; justify-content: center; align-items: center;">
//               <div style="width: 150px; height: 150px; border: 2px solid #447793; border-radius: 10px; display: flex; flex-direction: column; align-items: center; justify-content: center; background-color: #f9f9f9; padding: 10px; box-sizing: border-box;">
//                 <div style="font-size: 80px; line-height: 1; margin-bottom: 5px; color: #123249;">📱</div>
//                 <div style="font-size: 10px; text-align: center; color: #2D5A74;">Scan for Payment</div>
//                 <div style="font-size: 8px; text-align: center; color: #447793; margin-top: 5px;">UPI / QR Code</div>
//               </div>
//             </div>
//           </div>
          
//           <!-- Footer -->
//           <div style="background-color: #123249; color: white; padding: 15px; border-radius: 5px;">
//             <div style="display: flex; justify-content: center; gap: 30px; flex-wrap: wrap; margin-bottom: 5px;">
//               <span><strong>Phone:</strong> +91 80879 32436</span>
//               <span><strong>Email:</strong> info@blueskyenergy.in</span>
//               <span><strong>Web:</strong> www.blueskyenergy.in</span>
//             </div>
//             <div style="text-align: center; font-size: 11px; color: #DDE8ED;">
//               Plot No 62A, Umed Rd, Satyam nagar, Dighori, Nagpur - 440034 | Mon-Sun: 9AM-7PM
//             </div>
//           </div>
//         </div>
//       </div>
//     `;
//   };

//   const previewQuotation = () => {
//     calculateQuotationTotal(formData.items);
//     setShowPreview(true);
//   };

//   const editQuotation = () => {
//     setShowPreview(false);
//   };

//   const generatePDF = async () => {
//     try {
//       // First calculate totals
//       calculateQuotationTotal(formData.items);
      
//       // Create a temporary div to render the quotation
//       const tempDiv = document.createElement('div');
//       tempDiv.innerHTML = generateQuotationHTML();
//       document.body.appendChild(tempDiv);
      
//       const element = document.getElementById('quotation-pdf-content');
      
//       if (!element) {
//         alert("Could not generate quotation preview.");
//         return;
//       }

//       const filename = `Quotation_${formData.quotationNumber}.pdf`;

//       const canvas = await html2canvas(element, { 
//         scale: 2,
//         logging: false,
//         useCORS: true,
//         allowTaint: true,
//         backgroundColor: '#ffffff',
//         windowWidth: 800,
//         windowHeight: element.scrollHeight
//       });

//       // Remove temporary div
//       document.body.removeChild(tempDiv);

//       const pdf = new jsPDF({
//         orientation: 'p',
//         unit: 'mm',
//         format: 'a4'
//       });
      
//       const imgData = canvas.toDataURL('image/png');
//       const imgWidth = 210;
//       const imgHeight = canvas.height * imgWidth / canvas.width;
      
//       pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      
//       pdf.save(filename);
//       alert(`Quotation PDF downloaded successfully!`);

//     } catch (error) {
//       console.error("PDF Generation Error:", error);
//       alert("Could not generate PDF. Please check the console for details.");
//     }
//   };

//   return (
//     <div style={styles.container}>
//       {/* Add responsive CSS */}
//       <style>{`
//         @media (max-width: 768px) {
//           .quotation-container { padding: 15px !important; }
//           .header-title { font-size: 1.5rem !important; }
//           .btn { width: 100% !important; margin: 5px 0 !important; }
//           .grid-2 { grid-template-columns: 1fr !important; }
//           .table-responsive { margin: 0 -15px 15px -15px; }
//           .action-buttons { flex-direction: column !important; }
//           .mobile-note { display: block !important; }
//           .input-group { flex-direction: column !important; }
//           .input-group button { width: 100% !important; }
//         }
//         @media (max-width: 480px) {
//           .quotation-preview { padding: 10px !important; }
//           .quotation-preview table { font-size: 10px !important; }
//         }
//       `}</style>

//       <div style={styles.header}>
//         <h1 style={styles.headerTitle} className="header-title">Create Quotation - Blue Sky Energy</h1>
//         <div style={styles.headerActions}>
//           <button 
//             style={{...styles.btn, ...styles.btnOutlinePrimary}}
//             onClick={() => navigate('/')}
//             className="btn"
//           >
//             <i className="fas fa-arrow-left"></i> Back
//           </button>
//         </div>
//       </div>

//       {pdfError && (
//         <div style={styles.errorMessage}>
//           {pdfError}
//         </div>
//       )}

//       <div style={{...styles.quotationContainer, ...(showPreview ? styles.hidden : {})}} className="quotation-container">
//         <form id="quotationForm">
//           <div style={styles.grid2} className="grid-2">
//             <div>
//               <div style={styles.formGroup}>
//                 <label style={styles.label} htmlFor="quotationNumber">Quotation #</label>
//                 <input 
//                   type="text" 
//                   style={styles.input} 
//                   id="quotationNumber" 
//                   value={formData.quotationNumber}
//                   onChange={handleInputChange}
//                   required 
//                 />
//               </div>
//               <div style={styles.formGroup}>
//                 <label style={styles.label} htmlFor="quotationDate">Quotation Date</label>
//                 <input 
//                   type="date" 
//                   style={styles.input} 
//                   id="quotationDate" 
//                   value={formData.quotationDate}
//                   onChange={handleInputChange}
//                   required 
//                 />
//               </div>
//             </div>
//             <div>
//               <div style={styles.formGroup}>
//                 <label style={styles.label} htmlFor="validUntil">Valid Until</label>
//                 <input 
//                   type="date" 
//                   style={styles.input} 
//                   id="validUntil" 
//                   value={formData.validUntil}
//                   onChange={handleInputChange}
//                   required 
//                 />
//               </div>
//             </div>
//           </div>

//           <div style={styles.grid2} className="grid-2">
//             <div>
//               <div style={styles.formGroup}>
//                 <label style={styles.label} htmlFor="quotationClientName">To (Company/Client Name)</label>
//                 <input 
//                   type="text" 
//                   style={styles.input} 
//                   id="quotationClientName"
//                   placeholder="Enter company/client name" 
//                   value={formData.clientName}
//                   onChange={handleInputChange}
//                   required 
//                 />
//               </div>
//               <div style={styles.formGroup}>
//                 <label style={styles.label} htmlFor="quotationClientAddress">Address</label>
//                 <textarea 
//                   style={styles.textarea} 
//                   id="quotationClientAddress" 
//                   rows="2"
//                   placeholder="Enter address" 
//                   value={formData.clientAddress}
//                   onChange={handleInputChange}
//                   required 
//                 />
//               </div>
//             </div>
//             <div>
//               <div style={styles.formGroup}>
//                 <label style={styles.label} htmlFor="projectName">Project Name</label>
//                 <input 
//                   type="text" 
//                   style={styles.input} 
//                   id="projectName" 
//                   placeholder="Enter project name"
//                   value={formData.projectName}
//                   onChange={handleInputChange}
//                   required 
//                 />
//               </div>
//             </div>
//           </div>

//           <div style={styles.mb4}>
//             <label style={styles.label} htmlFor="projectDescription">Project Description</label>
//             <textarea 
//               style={styles.textarea} 
//               id="projectDescription" 
//               rows="3"
//               placeholder="Describe the project in detail"
//               value={formData.projectDescription}
//               onChange={handleInputChange}
//             />
//           </div>

//           <div style={styles.mb4}>
//             <label style={styles.label}>Project Features (Point Wise)</label>
//             <div id="featuresList">
//               {formData.features.map((feature, index) => (
//                 <div key={index} style={styles.inputGroup} className="input-group">
//                   <input 
//                     type="text" 
//                     style={{...styles.input, flex: 1}} 
//                     placeholder="Feature description"
//                     value={feature}
//                     onChange={(e) => handleFeatureChange(index, e.target.value)}
//                   />
//                   {formData.features.length > 1 && (
//                     <button 
//                       type="button" 
//                       style={{...styles.btn, ...styles.btnOutlineDanger, ...styles.btnSm}} 
//                       onClick={() => removeFeature(index)}
//                     >
//                       <i className="fas fa-trash"></i>
//                     </button>
//                   )}
//                 </div>
//               ))}
//             </div>
//             <button 
//               type="button" 
//               style={{...styles.btn, ...styles.btnOutlinePrimary}} 
//               onClick={addFeature}
//               className="btn"
//             >
//               <i className="fas fa-plus"></i> Add Feature
//             </button>
//           </div>

//           <h5 style={{marginBottom: '15px', color: theme.dark}}>Pricing</h5>
//           <div style={styles.tableResponsive} className="table-responsive">
//             <div className="mobile-note" style={styles.mobileNote}>← Swipe to see all columns →</div>
//             <table style={styles.table}>
//               <thead>
//                 <tr>
//                   <th style={styles.th}>#</th>
//                   <th style={styles.th}>Feature</th>
//                   <th style={styles.th}>Description</th>
//                   <th style={styles.th}>Amount (₹)</th>
//                   <th style={styles.th}>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {formData.items.map((item, index) => (
//                   <tr key={index}>
//                     <td style={styles.td}>{index + 1}</td>
//                     <td style={styles.td}>
//                       <input 
//                         type="text" 
//                         style={styles.inputSm} 
//                         placeholder="Feature name"
//                         value={item.feature}
//                         onChange={(e) => handleQuotationItemChange(index, 'feature', e.target.value)}
//                       />
//                     </td>
//                     <td style={styles.td}>
//                       <input 
//                         type="text" 
//                         style={styles.inputSm} 
//                         placeholder="Description"
//                         value={item.description}
//                         onChange={(e) => handleQuotationItemChange(index, 'description', e.target.value)}
//                       />
//                     </td>
//                     <td style={styles.td}>
//                       <input 
//                         type="number" 
//                         style={styles.inputSm} 
//                         placeholder="Amount"
//                         min="0" 
//                         step="0.01" 
//                         value={item.amount}
//                         onChange={(e) => handleQuotationItemChange(index, 'amount', e.target.value)}
//                       />
//                     </td>
//                     <td style={styles.td}>
//                       {formData.items.length > 1 && (
//                         <button 
//                           type="button" 
//                           style={{...styles.btn, ...styles.btnDanger, ...styles.btnSm}} 
//                           onClick={() => removeQuotationItem(index)}
//                         >
//                           <i className="fas fa-trash"></i>
//                         </button>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>

//           <div style={styles.mb3}>
//             <button 
//               type="button" 
//               style={{...styles.btn, ...styles.btnOutlinePrimary}} 
//               onClick={addQuotationItem}
//               className="btn"
//             >
//               <i className="fas fa-plus"></i> Add Item
//             </button>
//           </div>

//           <div style={styles.grid2} className="grid-2">
//             <div>
//               <div style={styles.formGroup}>
//                 <label style={styles.label} htmlFor="quotationTotal">Total Amount (₹)</label>
//                 <input 
//                   type="number" 
//                   style={styles.input} 
//                   id="quotationTotal" 
//                   readOnly 
//                   value={formData.totalAmount}
//                 />
//               </div>
//             </div>
//           </div>

//           <div style={styles.grid2} className="grid-2">
//             <div>
//               <div style={styles.formGroup}>
//                 <label style={styles.label} htmlFor="timelineDays">Timeline (Days)</label>
//                 <input 
//                   type="number" 
//                   style={styles.input} 
//                   id="timelineDays" 
//                   min="0"
//                   placeholder="Enter days"
//                   value={formData.timelineDays}
//                   onChange={handleInputChange}
//                 />
//               </div>
//             </div>
//             <div>
//               <div style={styles.formGroup}>
//                 <label style={styles.label} htmlFor="timelineMonths">Timeline (Months)</label>
//                 <input 
//                   type="number" 
//                   style={styles.input} 
//                   id="timelineMonths" 
//                   min="0"
//                   placeholder="Enter months"
//                   value={formData.timelineMonths}
//                   onChange={handleInputChange}
//                 />
//               </div>
//             </div>
//           </div>

//           <div style={styles.mb3}>
//             <label style={styles.label} htmlFor="advancePercentage">Advance Payment Percentage</label>
//             <input 
//               type="number" 
//               style={styles.input} 
//               id="advancePercentage" 
//               min="0" 
//               max="100" 
//               value={formData.advancePercentage}
//               onChange={handleInputChange}
//             />
//           </div>

//           <div style={styles.actionButtons} className="action-buttons">
//             <button 
//               type="button" 
//               style={{...styles.btn, ...styles.btnPrimary}} 
//               onClick={previewQuotation}
//               className="btn"
//             >
//               Preview Quotation
//             </button>
//             <button 
//               type="button" 
//               style={{...styles.btn, ...styles.btnSuccess}} 
//               onClick={generatePDF}
//               className="btn"
//             >
//               <i className="fas fa-download"></i> Download PDF
//             </button>
//           </div>
//         </form>
//       </div>

//       <div style={{...styles.quotationPreview, ...(showPreview ? {} : styles.hidden)}} className="quotation-preview">
//         <div style={styles.textCenter}>
//           <h3 style={{margin: '0 0 15px', color: theme.dark}}>Quotation Preview</h3>
//         </div>
//         <div 
//           ref={previewRef}
//           dangerouslySetInnerHTML={{ __html: generateQuotationHTML() }}
//         />
//         <div style={{...styles.actionButtons, marginTop: '20px'}} className="action-buttons">
//           <button 
//             type="button" 
//             style={{...styles.btn, ...styles.btnPrimary}} 
//             onClick={editQuotation}
//             className="btn"
//           >
//             Edit Quotation
//           </button>
//           <button 
//             type="button" 
//             style={{...styles.btn, ...styles.btnSuccess}} 
//             onClick={generatePDF}
//             className="btn"
//           >
//             <i className="fas fa-download"></i> Download PDF
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Quotation;































// components/Admin/Quotation.js
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

const Quotation = () => {
  const navigate = useNavigate();
  const [quotationType, setQuotationType] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [quotationHistory, setQuotationHistory] = useState([]);
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  
  const [formData, setFormData] = useState({
    // Common fields
    quotationNumber: '',
    quotationDate: new Date().toISOString().split('T')[0],
    clientName: '',
    clientAddress: '',
    proposalType: '',
    refNo: '',
    
    // Residential specific
    residentialCapacity: '5 KWp',
    residentialPanels: 'Topcon DCR Bifacial Solar Panels 600-620Wp',
    residentialInverter: '5 kW Grid-Tied Inverter',
    residentialTotal: '266300',
    residentialGST: '23700',
    residentialFinalTotal: '290000',
    residentialSubsidy: '78000',
    residentialNetPayable: '212000',
    
    // Payment terms
    advancePercent: '30',
    structurePayment: '60',
    balancePayment: '10',
    workCommencement: '3-5',
    installationTime: '3-5',
    
    // Bank details
    bankName: 'Equitas Small Finance Bank',
    branch: 'Bahadura Nagpur',
    accountNumber: '200002099026',
    ifscCode: 'ESFB0009040',
    mobileNo: '8087932436',
    gstNo: '27EJUPK2866R2ZW',
    email: 'blueskyenergy.ngp@gmail.com',
    phone1: '8087932436',
    phone2: '9423922066'
  });

  const previewRef = useRef(null);
  const [pdfError, setPdfError] = useState(null);

  // Exact color palette from screenshots
  const theme = {
    primary: '#1E3A5F',      // Dark blue for headers
    secondary: '#2B5797',     // Medium blue for accents
    light: '#E8F0FE',        // Light blue for table headers
    border: '#2B5797',        // Blue for borders
    white: '#FFFFFF',
    text: '#333333',          // Dark gray for text
    tableHeader: '#E8F0FE',
    priceHighlight: '#1E3A5F'
  };

  const styles = {
    container: {
      fontFamily: 'Arial, Helvetica, sans-serif',
      backgroundColor: '#f5f7fa',
      minHeight: '100vh',
      color: theme.text,
      display: 'flex',
      flexDirection: 'column',
      padding: '20px',
      boxSizing: 'border-box'
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '30px',
      paddingBottom: '15px',
      borderBottom: `2px solid ${theme.primary}`,
      flexWrap: 'wrap',
      gap: '15px'
    },
    headerTitle: {
      fontSize: 'clamp(1.2rem, 4vw, 2rem)',
      color: theme.primary,
      fontWeight: 600,
      margin: 0
    },
    headerActions: {
      display: 'flex',
      gap: '10px',
      flexWrap: 'wrap'
    },
    btn: {
      padding: '10px 20px',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: 500,
      transition: 'all 0.3s ease',
      textDecoration: 'none',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px'
    },
    btnOutlinePrimary: {
      background: 'transparent',
      border: `1px solid ${theme.primary}`,
      color: theme.primary
    },
    btnPrimary: {
      background: theme.primary,
      color: 'white'
    },
    btnSuccess: {
      background: theme.secondary,
      color: 'white'
    },
    btnDanger: {
      background: '#e74c3c',
      color: 'white'
    },
    btnSm: {
      padding: '6px 12px',
      fontSize: '12px'
    },
    btnDisabled: {
      opacity: 0.6,
      cursor: 'not-allowed'
    },
    typeSelection: {
      display: 'flex',
      justifyContent: 'center',
      gap: '30px',
      margin: '50px 0',
      flexWrap: 'wrap'
    },
    typeCard: {
      background: 'white',
      borderRadius: '10px',
      padding: '40px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      textAlign: 'center',
      minWidth: '250px',
      border: '2px solid transparent'
    },
    typeCardSelected: {
      border: `2px solid ${theme.primary}`,
      transform: 'scale(1.05)',
      boxShadow: '0 8px 30px rgba(0,0,0,0.2)'
    },
    typeIcon: {
      fontSize: '48px',
      marginBottom: '20px',
      color: theme.primary
    },
    typeTitle: {
      fontSize: '24px',
      fontWeight: 600,
      color: theme.primary,
      marginBottom: '10px'
    },
    quotationContainer: {
      background: 'white',
      borderRadius: '10px',
      padding: '30px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
      marginBottom: '30px'
    },
    formGroup: {
      marginBottom: '20px'
    },
    label: {
      display: 'block',
      marginBottom: '8px',
      fontWeight: 500,
      color: theme.primary
    },
    input: {
      width: '100%',
      padding: '12px 15px',
      border: `1px solid #ddd`,
      borderRadius: '5px',
      fontSize: '14px',
      outline: 'none',
      boxSizing: 'border-box'
    },
    grid2: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '20px',
      marginBottom: '20px'
    },
    grid3: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '20px',
      marginBottom: '20px'
    },
    sectionTitle: {
      fontSize: '18px',
      color: theme.primary,
      marginBottom: '20px',
      paddingBottom: '10px',
      borderBottom: `2px solid ${theme.primary}`
    },
    hidden: {
      display: 'none'
    },
    historySection: {
      marginTop: '40px',
      background: 'white',
      borderRadius: '10px',
      padding: '20px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
    },
    historyItem: {
      padding: '15px',
      borderBottom: `1px solid #ddd`,
      cursor: 'pointer',
      transition: 'background 0.3s ease',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '10px'
    },
    badge: {
      padding: '5px 10px',
      borderRadius: '15px',
      fontSize: '12px',
      fontWeight: 500
    },
    badgeResidential: {
      background: theme.secondary,
      color: 'white'
    },
    previewContainer: {
      border: `1px solid #ddd`,
      padding: '20px',
      backgroundColor: 'white',
      marginTop: '20px',
      borderRadius: '10px',
      overflowX: 'auto'
    },
    errorMessage: {
      backgroundColor: '#fee',
      color: '#c00',
      padding: '10px',
      borderRadius: '5px',
      marginBottom: '20px',
      textAlign: 'center'
    },
    loadingOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999
    },
    loadingContent: {
      background: 'white',
      padding: '30px',
      borderRadius: '10px',
      textAlign: 'center'
    }
  };

  // Load history from localStorage
  useEffect(() => {
    const savedHistory = localStorage.getItem('quotationHistory');
    if (savedHistory) {
      setQuotationHistory(JSON.parse(savedHistory));
    }
  }, []);

  // Set default quotation number
  useEffect(() => {
    if (quotationType === 'residential') {
      setFormData(prev => ({
        ...prev,
        quotationNumber: `BSE/NGP/${Math.floor(1000 + Math.random() * 9000)}/25/26`,
        proposalType: '5 KWp RESIDENTIAL',
        refNo: `BSE/NGP/1090/25/26`
      }));
    }
    setShowForm(true);
  }, [quotationType]);

  const handleTypeSelect = (type) => {
    setQuotationType(type);
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };

  const handleBack = () => {
    setQuotationType(null);
    setShowForm(false);
    setShowPreview(false);
    setSelectedHistory(null);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Safe image render function - no onerror errors
  const renderLogo = () => {
    return `
      <div style="width: 80px; height: 80px; background: linear-gradient(135deg, #1E3A5F, #2B5797); border-radius: 5px; display: flex; align-items: center; justify-content: center; margin-right: 15px; color: white; font-size: 40px;">
        ☀️
      </div>
    `;
  };

  const renderSystemDiagram = () => {
    return `
      <div style="height: 300px; margin-bottom: 20px; border: 1px solid #2B5797; display: flex; align-items: center; justify-content: center; background: white; color: #1E3A5F; font-size: 24px;">
        🔆 Solar System Diagram 🔆
      </div>
    `;
  };

  // PAGE 1: Header and Client Details
  const generatePage1 = () => {
    return `
      <div style="page-break-after: always; min-height: 1123px; padding: 40px; box-sizing: border-box; font-family: Arial, Helvetica, sans-serif;">
        
        <!-- Header with Logo and Title -->
        <div style="text-align: center; margin-bottom: 40px;">
          <div style="display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
            ${renderLogo()}
            <h1 style="font-size: 36px; font-weight: bold; color: #1E3A5F; margin: 0; letter-spacing: 1px;">BLUE SKY ENERGY</h1>
          </div>
          
          <h2 style="font-size: 24px; color: #1E3A5F; margin: 20px 0; font-weight: bold;">RESIDENTIAL PROPOSAL [5 KWp]</h2>
        </div>

        <!-- Client Details Table -->
        <table style="width: 100%; border-collapse: collapse; margin: 30px 0; font-size: 14px; border: 2px solid #2B5797;">
          <tr>
            <td style="border: 1px solid #2B5797; padding: 15px; background: #E8F0FE; font-weight: bold; color: #1E3A5F; width: 30%;">CLIENT NAME</td>
            <td style="border: 1px solid #2B5797; padding: 15px; color: #333;">${formData.clientName || 'MR. Mahindra yadav'}</td>
          </tr>
          <tr>
            <td style="border: 1px solid #2B5797; padding: 15px; background: #E8F0FE; font-weight: bold; color: #1E3A5F;">ADDRESS</td>
            <td style="border: 1px solid #2B5797; padding: 15px; color: #333;">${formData.clientAddress || 'Nagpur'}</td>
          </tr>
          <tr>
            <td style="border: 1px solid #2B5797; padding: 15px; background: #E8F0FE; font-weight: bold; color: #1E3A5F;">PROPOSAL</td>
            <td style="border: 1px solid #2B5797; padding: 15px; color: #333;">5 KWp RESIDENTIAL</td>
          </tr>
          <tr>
            <td style="border: 1px solid #2B5797; padding: 15px; background: #E8F0FE; font-weight: bold; color: #1E3A5F;">REF.NO.</td>
            <td style="border: 1px solid #2B5797; padding: 15px; color: #333;">${formData.refNo}</td>
          </tr>
          <tr>
            <td style="border: 1px solid #2B5797; padding: 15px; background: #E8F0FE; font-weight: bold; color: #1E3A5F;">DATE</td>
            <td style="border: 1px solid #2B5797; padding: 15px; color: #333;">${formatDate(formData.quotationDate)}</td>
          </tr>
        </table>
      </div>
    `;
  };

  // PAGE 2: Working Description and System Diagram
  const generatePage2 = () => {
    return `
      <div style="page-break-after: always; min-height: 1123px; padding: 40px; box-sizing: border-box; font-family: Arial, Helvetica, sans-serif;">
        
        <p style="margin: 20px 0; color: #333; line-height: 1.6; font-size: 14px;">
          With reference to our recent discussion regarding your proposed installation of a grid-connected solar PV system, we are pleased to submit our detailed quotation for your kind consideration.
        </p>
        
        <p style="margin: 20px 0; color: #333; line-height: 1.6; font-size: 14px;">
          We shall be glad to provide any clarification or additional information that you may require and look forward to serving you with a reliable and efficient solar energy solution.
        </p>

        <hr style="border: 1px dashed #2B5797; margin: 30px 0;">

        <h2 style="color: #1E3A5F; font-size: 18px; margin: 25px 0 15px; font-weight: bold;">Working of the Grid-Connected Solar PV System</h2>
        
        <p style="margin: 15px 0; color: #333; line-height: 1.6; font-size: 14px;">
          During daytime, the solar photovoltaic (PV) modules generate electrical energy in the form of <strong>Direct Current (DC)</strong>. This DC power flows from the solar array through DC cables and a <strong>DC isolator</strong> to the inverter.
        </p>
        
        <p style="margin: 15px 0; color: #333; line-height: 1.6; font-size: 14px;">
          The inverter converts the DC power into <strong>Alternating Current (AC)</strong>, making it suitable for use within the premises. The converted AC power is supplied to the building's electrical system through an <strong>AC isolator</strong> and a <strong>generation meter</strong>, operating in parallel with the existing utility supply.
        </p>
        
        <p style="margin: 15px 0; color: #333; line-height: 1.6; font-size: 14px;">
          The electricity generated by the solar PV system is first utilized to meet the connected load during daylight hours. If the solar generation is insufficient, the remaining power requirement is automatically drawn from the utility grid.
        </p>
        
        <p style="margin: 15px 0; color: #333; line-height: 1.6; font-size: 14px;">
          In the proposed configuration, power to the local load—up to the instantaneous available capacity of the solar array and within the inverter's rated capacity—is supplied by the solar inverter, with any additional power requirement sourced from the utility grid or DG, if applicable.
        </p>

        <hr style="border: 1px dashed #2B5797; margin: 30px 0;">

        <h2 style="color: #1E3A5F; font-size: 18px; margin: 20px 0 15px; font-weight: bold;">Proposed System Diagram</h2>
        
        <!-- System Diagram Box -->
        <div style="margin: 20px 0; border: 2px solid #2B5797; border-radius: 5px; padding: 25px; background: #F9F9F9;">
          
          ${renderSystemDiagram()}
          
          <!-- System Components List -->
          <div style="font-size: 13px; color: #333; line-height: 1.8;">
            <p><strong>1. Solar Array Converters</strong> - Energy from sunlight to electricity</p>
            <p><strong>2. Inverter Converters</strong> - Electricity produced by the solar array from direct current (DC) to alternating current (AC)</p>
            <p><strong>3. Main Switch</strong> - The AC Current then goes to the Main Switch</p>
            <p><strong>4. Battery Panels</strong> - Monitoring Structure, Interactive Inverters, Main Battery, Consumer Loads, Net Meter, Grid Utility, Storage/Splice Arrester</p>
            <p><strong>5. Excess Energy Goes to the Electric Grid</strong></p>
            <p><strong>6. The Net Meter Indicates</strong> the Amount of Energy Used and the Maximum Energy Produced</p>
          </div>
        </div>

        <div style="font-size: 11px; color: #666; text-align: center; margin-top: 40px; border-top: 1px dashed #2B5797; padding-top: 15px;">
          OFFICE ADDRESS: 372, Sanjay Gandhi Nagar, Manewada, Ring Road, Opp Royal Furniture Nagpur 440024.
        </div>
      </div>
    `;
  };

  // PAGE 3: Specifications Table and Warranty
  const generatePage3 = () => {
    return `
      <div style="page-break-after: always; min-height: 1123px; padding: 40px; box-sizing: border-box; font-family: Arial, Helvetica, sans-serif;">
        
        <h2 style="color: #1E3A5F; font-size: 22px; margin: 0 0 25px; font-weight: bold; text-align: center;">5 KWp On-Grid System Specifications</h2>
        
        <!-- Specifications Table -->
        <table style="width: 100%; border-collapse: collapse; margin: 20px 0; font-size: 12px; border: 1px solid #2B5797;">
          <thead>
            <tr>
              <th style="border: 1px solid #2B5797; padding: 12px; background: #E8F0FE; color: #1E3A5F; font-weight: bold; text-align: left;">Item</th>
              <th style="border: 1px solid #2B5797; padding: 12px; background: #E8F0FE; color: #1E3A5F; font-weight: bold; text-align: left;">Specification</th>
              <th style="border: 1px solid #2B5797; padding: 12px; background: #E8F0FE; color: #1E3A5F; font-weight: bold; text-align: left;">Make</th>
              <th style="border: 1px solid #2B5797; padding: 12px; background: #E8F0FE; color: #1E3A5F; font-weight: bold; text-align: left;">Standards</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: 1px solid #2B5797; padding: 10px;">Solar Panels</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Topcon DCR Bifacial Solar Panels of rating [600-620WP]</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Adani/waaree /premeir As Per Availability</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">IEC 61215, IEC 61730, IEC 61701, IEC 62716, MNRE Approved</td>
            </tr>
            <tr>
              <td style="border: 1px solid #2B5797; padding: 10px;">Inverter</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">5 kW Grid-Tied Inverter</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Polycab/sunsathi As per Availability</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">IEC / CE / VDE / BDEW</td>
            </tr>
            <tr>
              <td style="border: 1px solid #2B5797; padding: 10px;">Inverter Monitoring</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Internet & Mobile App based monitoring</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">As per inverter As Per Availability</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">—</td>
            </tr>
            <tr>
              <td style="border: 1px solid #2B5797; padding: 10px;">DC Cables</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Solar DC cables with MC4 connectors (1500V DC)</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Polycab / KEI / Seichem As Per Availability</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">IEC 60227, IS 694</td>
            </tr>
            <tr>
              <td style="border: 1px solid #2B5797; padding: 10px;">AC Cables</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Inverter to LT Panel cables (1100V AC)</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Havells / Polycab / KEI As Per Availability</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">IS Standards</td>
            </tr>
            <tr>
              <td style="border: 1px solid #2B5797; padding: 10px;">Mounting Structure</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Galvanize Structure with Anti-Rust coupling. Designed to withstand wind speed and seismic factors of the site. Height (7x9) Size - (3/3 Square tube)</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Fortune / Vikrant As Per Availability</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Heavy duty</td>
            </tr>
            <tr>
              <td style="border: 1px solid #2B5797; padding: 10px;">DC Junction Box</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">IP65 with fuse & surge protection</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Havells / Elmax / Equivalent As Per Availability</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">IEC 60364-5-53</td>
            </tr>
            <tr>
              <td style="border: 1px solid #2B5797; padding: 10px;">AC Distribution Box</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">MCB + SPD in IP enclosure</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Havells / Elmax / Equivalent As Per Availability</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">IEC 60364-5-53</td>
            </tr>
            <tr>
              <td style="border: 1px solid #2B5797; padding: 10px;">Earthing & LA</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Separate earthling & lightning arrester</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Reputed Make As Per Availability</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">As per norms</td>
            </tr>
            <tr>
              <td style="border: 1px solid #2B5797; padding: 10px;">Net Meter</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Bi-Directional Energy Meter</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Secure / HPL / L&T As Per Availability</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">MSEDCL Approved</td>
            </tr>
          </tbody>
        </table>

        <h3 style="color: #1E3A5F; font-size: 16px; margin: 30px 0 15px; font-weight: bold;">Product Warranty / Manufacturing Defect Warranty</h3>
        
        <!-- Warranty Table -->
        <table style="width: 100%; border-collapse: collapse; margin: 20px 0; font-size: 13px; border: 1px solid #2B5797;">
          <thead>
            <tr>
              <th style="border: 1px solid #2B5797; padding: 12px; background: #E8F0FE; color: #1E3A5F;">Sr. No</th>
              <th style="border: 1px solid #2B5797; padding: 12px; background: #E8F0FE; color: #1E3A5F;">Component</th>
              <th style="border: 1px solid #2B5797; padding: 12px; background: #E8F0FE; color: #1E3A5F;">Warranty (In Years)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: 1px solid #2B5797; padding: 10px;">1</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Solar modules</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">30 Years</td>
            </tr>
            <tr>
              <td style="border: 1px solid #2B5797; padding: 10px;">2</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Inverter</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">8 Years</td>
            </tr>
            <tr>
              <td style="border: 1px solid #2B5797; padding: 10px;">3</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Module Mounting Structure</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">5 Years</td>
            </tr>
            <tr>
              <td style="border: 1px solid #2B5797; padding: 10px;">4</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Other BOS</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">As per Original Equipment Manufacture warranty terms</td>
            </tr>
          </tbody>
        </table>

        <div style="font-size: 11px; color: #666; text-align: center; margin-top: 40px;">
          OFFICE ADDRESS: 372, Sanjay Gandhi Nagar, Manewada, Ring Road, Opp Royal Furniture Nagpur 440024.
        </div>
      </div>
    `;
  };

  // PAGE 4: Price Details and Subsidy Calculation
  const generatePage4 = () => {
    return `
      <div style="page-break-after: always; min-height: 1123px; padding: 40px; box-sizing: border-box; font-family: Arial, Helvetica, sans-serif;">
        
        <!-- GST and Contact Info -->
        <div style="margin-bottom: 30px;">
          <div style="display: flex; justify-content: space-between; align-items: center; background: #E8F0FE; padding: 15px; border: 1px solid #2B5797; border-bottom: none;">
            <span style="color: #1E3A5F; font-weight: bold;">GST NO: ${formData.gstNo}</span>
            <span style="color: #1E3A5F;">${formData.email}</span>
            <span style="color: #1E3A5F;">+91 ${formData.phone1}</span>
          </div>
          <div style="display: flex; justify-content: center; align-items: center; background: #E8F0FE; padding: 15px; border: 1px solid #2B5797; border-top: none;">
            <span style="color: #1E3A5F;">+91 ${formData.phone2}</span>
          </div>
        </div>

        <h2 style="color: #1E3A5F; font-size: 22px; margin: 20px 0 25px; font-weight: bold; text-align: center;">RESIDENTIAL OFFER – PRICE DETAILS</h2>
        
        <!-- Price Table -->
        <table style="width: 100%; border-collapse: collapse; margin: 25px 0; font-size: 13px; border: 1px solid #2B5797;">
          <thead>
            <tr>
              <th style="border: 1px solid #2B5797; padding: 12px; background: #E8F0FE; color: #1E3A5F; text-align: left;">Sr. No.</th>
              <th style="border: 1px solid #2B5797; padding: 12px; background: #E8F0FE; color: #1E3A5F; text-align: left;">Description</th>
              <th style="border: 1px solid #2B5797; padding: 12px; background: #E8F0FE; color: #1E3A5F; text-align: left;">Inverter Type</th>
              <th style="border: 1px solid #2B5797; padding: 12px; background: #E8F0FE; color: #1E3A5F; text-align: left;">Unit Price (₹)</th>
              <th style="border: 1px solid #2B5797; padding: 12px; background: #E8F0FE; color: #1E3A5F; text-align: left;">Qty</th>
              <th style="border: 1px solid #2B5797; padding: 12px; background: #E8F0FE; color: #1E3A5F; text-align: left;">Amount (₹)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: 1px solid #2B5797; padding: 10px;">1</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Supply of Solar On-Grid Power Plant as per approved Bill of Material (DCR Bifacial Solar Panels – 600/620 Wp Total Capacity: 5 kW)</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">On-Grid</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">${parseInt(formData.residentialTotal).toLocaleString()}</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">1 Set</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">${parseInt(formData.residentialTotal).toLocaleString()}/-</td>
            </tr>
            <tr>
              <td style="border: 1px solid #2B5797; padding: 10px;">2</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Net Metering & Documentation Liaisoning, feasibility study & approvals from concerned authority</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">—</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Included</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">1 Set</td>
              <td style="border: 1px solid #2B5797; padding: 10px;">Included</td>
            </tr>
            <tr style="background: #F5F5F5;">
              <td colspan="5" style="border: 1px solid #2B5797; padding: 12px; text-align: right; font-weight: bold;">Project Value (Before GST)</td>
              <td style="border: 1px solid #2B5797; padding: 12px; font-weight: bold;">${parseInt(formData.residentialTotal).toLocaleString()}/-</td>
            </tr>
            <tr>
              <td colspan="5" style="border: 1px solid #2B5797; padding: 12px; text-align: right;">GST @ 8.9% (As per Government norms)</td>
              <td style="border: 1px solid #2B5797; padding: 12px;">${parseInt(formData.residentialGST).toLocaleString()}/-</td>
            </tr>
            <tr style="background: #1E3A5F; color: white; font-weight: bold;">
              <td colspan="5" style="border: 1px solid #2B5797; padding: 15px; text-align: right; font-size: 16px;">Total Project Amount</td>
              <td style="border: 1px solid #2B5797; padding: 15px; font-size: 16px;">₹${parseInt(formData.residentialFinalTotal).toLocaleString()}/-</td>
            </tr>
          </tbody>
        </table>

        <hr style="border: 1px dashed #2B5797; margin: 30px 0;">

        <h2 style="color: #1E3A5F; font-size: 20px; margin: 20px 0; font-weight: bold; text-align: center;">RESIDENTIAL SOLAR SUBSIDY CALCULATION</h2>
        
        <!-- Subsidy Table -->
        <table style="width: 100%; border-collapse: collapse; margin: 20px 0; font-size: 14px; border: 1px solid #2B5797;">
          <thead>
            <tr>
              <th style="border: 1px solid #2B5797; padding: 12px; background: #E8F0FE; color: #1E3A5F; text-align: left;">Description</th>
              <th style="border: 1px solid #2B5797; padding: 12px; background: #E8F0FE; color: #1E3A5F; text-align: left;">Amount (₹)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: 1px solid #2B5797; padding: 12px;">Total Project Cost (Including GST)</td>
              <td style="border: 1px solid #2B5797; padding: 12px;">₹${parseInt(formData.residentialFinalTotal).toLocaleString()}/-</td>
            </tr>
            <tr>
              <td style="border: 1px solid #2B5797; padding: 12px;">MNRE Government Subsidy (Residential Only)</td>
              <td style="border: 1px solid #2B5797; padding: 12px;">- ₹${parseInt(formData.residentialSubsidy).toLocaleString()}/-</td>
            </tr>
            <tr style="background: #1E3A5F; color: white; font-weight: bold;">
              <td style="border: 1px solid #2B5797; padding: 15px;">FINAL NET AMOUNT PAYABLE</td>
              <td style="border: 1px solid #2B5797; padding: 15px;">₹${parseInt(formData.residentialNetPayable).toLocaleString()}/-</td>
            </tr>
          </tbody>
        </table>
      </div>
    `;
  };

  // PAGE 5: Terms, Conditions and Bank Details
  const generatePage5 = () => {
    return `
      <div style="page-break-after: always; min-height: 1123px; padding: 40px; box-sizing: border-box; font-family: Arial, Helvetica, sans-serif;">
        
        <h2 style="color: #1E3A5F; font-size: 22px; margin: 0 0 25px; font-weight: bold;">FLEXIBLE PAYMENT TERMS & CONDITIONS</h2>
        
        <div style="margin: 20px 0;">
          
          <!-- Payment Schedule -->
          <h3 style="color: #1E3A5F; font-size: 16px; margin: 20px 0 10px; font-weight: bold;">Payment Schedule</h3>
          <div style="margin: 10px 0 10px 20px;">
            <p style="margin: 8px 0; color: #333;"><strong style="color: #1E3A5F; width: 30px; display: inline-block;">•</strong> <strong>${formData.advancePercent}% advance</strong> of project value along with purchase order</p>
            <p style="margin: 8px 0; color: #333;"><strong style="color: #1E3A5F; width: 30px; display: inline-block;">•</strong> <strong>${formData.structurePayment}% payment</strong> after structure installation and DC wiring completion</p>
            <p style="margin: 8px 0; color: #333;"><strong style="color: #1E3A5F; width: 30px; display: inline-block;">•</strong> <strong>${formData.balancePayment}% balance</strong> after successful installation and system handover</p>
          </div>

          <!-- Project Timeline -->
          <h3 style="color: #1E3A5F; font-size: 16px; margin: 25px 0 10px; font-weight: bold;">Project Timeline</h3>
          <div style="margin: 10px 0 10px 20px;">
            <p style="margin: 8px 0; color: #333;"><strong style="color: #1E3A5F; width: 30px; display: inline-block;">•</strong> Work commencement within <strong>${formData.workCommencement} weeks</strong> of service order receipt</p>
            <p style="margin: 8px 0; color: #333;"><strong style="color: #1E3A5F; width: 30px; display: inline-block;">•</strong> Complete system installation within <strong>${formData.installationTime} weeks</strong> from commencement</p>
          </div>

          <!-- Scope & Changes -->
          <h3 style="color: #1E3A5F; font-size: 16px; margin: 25px 0 10px; font-weight: bold;">Scope & Changes</h3>
          <div style="margin: 10px 0 10px 20px;">
            <p style="margin: 8px 0; color: #333;"><strong style="color: #1E3A5F; width: 30px; display: inline-block;">•</strong> Any changes in structure design will be <strong>charged extra</strong></p>
            <p style="margin: 8px 0; color: #333;"><strong style="color: #1E3A5F; width: 30px; display: inline-block;">•</strong> Any additional work beyond the quotation scope will be <strong>charged at actual</strong></p>
          </div>

          <!-- Warranty & Service -->
          <h3 style="color: #1E3A5F; font-size: 16px; margin: 25px 0 10px; font-weight: bold;">Warranty & Service</h3>
          <div style="margin: 10px 0 10px 20px;">
            <p style="margin: 8px 0; color: #333;"><strong style="color: #1E3A5F; width: 30px; display: inline-block;">•</strong> System includes <strong>1-year warranty</strong> and <strong>5 years service support</strong></p>
            <p style="margin: 8px 0; color: #333;"><strong style="color: #1E3A5F; width: 30px; display: inline-block;">•</strong> Warranty is <strong>void</strong> in case of broken or tampered solar panels or inverter</p>
            <p style="margin: 8px 0; color: #333;"><strong style="color: #1E3A5F; width: 30px; display: inline-block;">•</strong> Physical damage due to <strong>natural calamities or other reasons</strong> is not covered</p>
          </div>

          <!-- General Terms -->
          <h3 style="color: #1E3A5F; font-size: 16px; margin: 25px 0 10px; font-weight: bold;">General Terms</h3>
          <div style="margin: 10px 0 10px 20px;">
            <p style="margin: 8px 0; color: #333;"><strong style="color: #1E3A5F; width: 30px; display: inline-block;">•</strong> System cost includes <strong>all materials specified in quotation and installation</strong></p>
            <p style="margin: 8px 0; color: #333;"><strong style="color: #1E3A5F; width: 30px; display: inline-block;">•</strong> Quotation validity: <strong>10 days</strong> from date of submission</p>
            <p style="margin: 8px 0; color: #333;"><strong style="color: #1E3A5F; width: 30px; display: inline-block;">•</strong> Any applicable <strong>Government taxes under GST</strong> will be charged as per rules</p>
            <p style="margin: 8px 0; color: #333;"><strong style="color: #1E3A5F; width: 30px; display: inline-block;">•</strong> <strong>Load extension</strong>, if required, will take up to <strong>30 days</strong> from application date</p>
            <p style="margin: 8px 0; color: #333;"><strong style="color: #1E3A5F; width: 30px; display: inline-block;">•</strong> Cost of <strong>demand / security deposit payable to MSEDCL</strong> shall be <strong>borne by the customer</strong></p>
            <p style="margin: 8px 0; color: #333;"><strong style="color: #1E3A5F; width: 30px; display: inline-block;">•</strong> Solar sanction approval will take <strong>minimum 7 working days</strong></p>
            <p style="margin: 8px 0; color: #333;"><strong style="color: #1E3A5F; width: 30px; display: inline-block;">•</strong> Rooftop solar system works <strong>only during daytime with On-Grid operation</strong></p>
          </div>

          <hr style="border: 1px dashed #2B5797; margin: 30px 0;">

          <!-- Bank Details -->
          <h3 style="color: #1E3A5F; font-size: 18px; margin: 20px 0 15px; font-weight: bold;">Bank details:</h3>
          <div style="background: #E8F0FE; padding: 25px; border-radius: 5px; border: 2px solid #2B5797;">
            <p style="margin: 10px 0; color: #333; font-size: 14px;"><strong style="color: #1E3A5F; width: 150px; display: inline-block;">Account name:</strong> Blue Sky Energy</p>
            <p style="margin: 10px 0; color: #333; font-size: 14px;"><strong style="color: #1E3A5F; width: 150px; display: inline-block;">Bank Name:</strong> ${formData.bankName}</p>
            <p style="margin: 10px 0; color: #333; font-size: 14px;"><strong style="color: #1E3A5F; width: 150px; display: inline-block;">Branch:</strong> ${formData.branch}</p>
            <p style="margin: 10px 0; color: #333; font-size: 14px;"><strong style="color: #1E3A5F; width: 150px; display: inline-block;">Account Number:</strong> ${formData.accountNumber}</p>
            <p style="margin: 10px 0; color: #333; font-size: 14px;"><strong style="color: #1E3A5F; width: 150px; display: inline-block;">Ifsc Code:</strong> ${formData.ifscCode}</p>
            <p style="margin: 10px 0; color: #333; font-size: 14px;"><strong style="color: #1E3A5F; width: 150px; display: inline-block;">Mobile No.:</strong> ${formData.mobileNo}</p>
          </div>
        </div>
      </div>
    `;
  };

  // Combine all pages
  const generateResidentialHTML = () => {
    return `
      <div id="quotation-pdf-content" style="width: 100%; max-width: 800px; margin: 0 auto; background: white;">
        ${generatePage1()}
        ${generatePage2()}
        ${generatePage3()}
        ${generatePage4()}
        ${generatePage5()}
      </div>
    `;
  };

  const previewQuotation = () => {
    setShowPreview(true);
  };

  const editQuotation = () => {
    setShowPreview(false);
  };

  const saveToHistory = () => {
    const historyItem = {
      id: Date.now(),
      type: quotationType,
      clientName: formData.clientName,
      quotationNumber: formData.quotationNumber,
      date: new Date().toISOString(),
      total: formData.residentialFinalTotal,
      data: { ...formData }
    };

    const updatedHistory = [historyItem, ...quotationHistory];
    setQuotationHistory(updatedHistory);
    localStorage.setItem('quotationHistory', JSON.stringify(updatedHistory));
  };

  const generatePDF = async () => {
    if (isGeneratingPDF) return;
    
    setIsGeneratingPDF(true);
    setPdfError(null);

    try {
      const html = generateResidentialHTML();
      
      // Create a temporary container
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      tempDiv.style.position = 'absolute';
      tempDiv.style.left = '-9999px';
      tempDiv.style.top = '-9999px';
      document.body.appendChild(tempDiv);
      
      const element = document.getElementById('quotation-pdf-content');
      
      if (!element) {
        throw new Error("Could not generate quotation preview.");
      }

      const filename = `Quotation_${formData.quotationNumber}_Residential.pdf`;

      // Wait a bit for fonts to load
      await new Promise(resolve => setTimeout(resolve, 500));

      const canvas = await html2canvas(element, { 
        scale: 2,
        logging: false,
        useCORS: true,
        allowTaint: false,
        backgroundColor: '#ffffff',
        windowWidth: 800,
        onclone: function(clonedDoc) {
          // Fix any styling issues in cloned document
          const clonedElement = clonedDoc.getElementById('quotation-pdf-content');
          if (clonedElement) {
            clonedElement.style.background = 'white';
          }
        }
      });

      // Remove temporary div
      document.body.removeChild(tempDiv);

      const pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
        compress: true
      });
      
      const imgData = canvas.toDataURL('image/jpeg', 1.0);
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      
      // Handle multi-page PDF
      let heightLeft = imgHeight;
      let position = 0;
      let pageCount = 1;

      pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight, undefined, 'FAST');
      heightLeft -= pdf.internal.pageSize.height;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight, undefined, 'FAST');
        heightLeft -= pdf.internal.pageSize.height;
        pageCount++;
      }
      
      pdf.save(filename);
      
      // Save to history after successful PDF generation
      saveToHistory();
      
      alert(`Residential Quotation PDF downloaded successfully! (${pageCount} pages)`);

    } catch (error) {
      console.error("PDF Generation Error:", error);
      setPdfError("Could not generate PDF. Please try again.");
      alert("Could not generate PDF. Please check the console for details.");
    } finally {
      setIsGeneratingPDF(false);
    }
  };

  const loadFromHistory = (item) => {
    setSelectedHistory(item);
    setFormData(item.data);
    setQuotationType(item.type);
    setShowForm(true);
    setShowPreview(false);
  };

  const deleteFromHistory = (id, e) => {
    e.stopPropagation();
    const updatedHistory = quotationHistory.filter(item => item.id !== id);
    setQuotationHistory(updatedHistory);
    localStorage.setItem('quotationHistory', JSON.stringify(updatedHistory));
  };

  return (
    <div style={styles.container}>
      <style>{`
        @media (max-width: 768px) {
          .quotation-container { padding: 15px !important; }
          .type-card { padding: 20px !important; min-width: 200px !important; }
          .action-buttons { flex-direction: column !important; }
          .action-buttons button { width: 100% !important; }
          .history-item { flex-direction: column !important; align-items: flex-start !important; }
        }
        .history-item:hover { background-color: #E8F0FE; }
      `}</style>

      {/* Loading Overlay */}
      {isGeneratingPDF && (
        <div style={styles.loadingOverlay}>
          <div style={styles.loadingContent}>
            <div style={{fontSize: '24px', marginBottom: '15px'}}>📄</div>
            <h3>Generating PDF...</h3>
            <p>Please wait while we create your quotation.</p>
          </div>
        </div>
      )}

      <div style={styles.header}>
        <h1 style={styles.headerTitle}>Blue Sky Energy - Quotation Generator</h1>
        <div style={styles.headerActions}>
          {(showForm || showPreview) && (
            <button 
              style={{...styles.btn, ...styles.btnOutlinePrimary}}
              onClick={handleBack}
              disabled={isGeneratingPDF}
            >
              ← Back to Selection
            </button>
          )}
          <button 
            style={{...styles.btn, ...styles.btnOutlinePrimary}}
            onClick={() => navigate('/')}
            disabled={isGeneratingPDF}
          >
            <i className="fas fa-home"></i> Dashboard
          </button>
        </div>
      </div>

      {pdfError && (
        <div style={styles.errorMessage}>
          {pdfError}
        </div>
      )}

      {!quotationType && !showForm && (
        <div style={styles.typeSelection}>
          <div 
            style={{...styles.typeCard}}
            onClick={() => !isGeneratingPDF && handleTypeSelect('commercial')}
            className="type-card"
          >
            <div style={styles.typeIcon}>🏢</div>
            <h2 style={styles.typeTitle}>Commercial</h2>
            <p style={styles.typeDesc}>For businesses, offices, and commercial establishments</p>
            <p style={{marginTop: '15px', color: theme.primary, fontWeight: 500}}>10 kWp System</p>
          </div>

          <div 
            style={{...styles.typeCard, ...(quotationType === 'residential' ? styles.typeCardSelected : {})}}
            onClick={() => !isGeneratingPDF && handleTypeSelect('residential')}
            className="type-card"
          >
            <div style={styles.typeIcon}>🏠</div>
            <h2 style={styles.typeTitle}>Residential</h2>
            <p style={styles.typeDesc}>For homes, apartments, and residential complexes</p>
            <p style={{marginTop: '15px', color: theme.primary, fontWeight: 500}}>5 kWp System with Subsidy</p>
          </div>
        </div>
      )}

      {showForm && !showPreview && (
        <div style={styles.quotationContainer} className="quotation-container">
          <h2 style={styles.sectionTitle}>
            Residential Quotation Details
          </h2>
          
          <div style={styles.grid2}>
            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="clientName">Client Name *</label>
              <input 
                type="text" 
                style={styles.input} 
                id="clientName" 
                placeholder="Enter client name"
                value={formData.clientName}
                onChange={handleInputChange}
                disabled={isGeneratingPDF}
                required 
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="clientAddress">Client Address *</label>
              <input 
                type="text" 
                style={styles.input} 
                id="clientAddress" 
                placeholder="Enter client address"
                value={formData.clientAddress}
                onChange={handleInputChange}
                disabled={isGeneratingPDF}
                required 
              />
            </div>
          </div>

          <div style={styles.grid2}>
            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="quotationNumber">Quotation Number</label>
              <input 
                type="text" 
                style={styles.input} 
                id="quotationNumber" 
                value={formData.quotationNumber}
                onChange={handleInputChange}
                disabled={isGeneratingPDF}
                readOnly
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="quotationDate">Quotation Date</label>
              <input 
                type="date" 
                style={styles.input} 
                id="quotationDate" 
                value={formData.quotationDate}
                onChange={handleInputChange}
                disabled={isGeneratingPDF}
              />
            </div>
          </div>

          <h3 style={{color: theme.primary, marginBottom: '15px'}}>Residential System Details</h3>
          <div style={styles.grid3}>
            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="residentialTotal">Total Amount (Before GST)</label>
              <input 
                type="number" 
                style={styles.input} 
                id="residentialTotal" 
                value={formData.residentialTotal}
                onChange={handleInputChange}
                disabled={isGeneratingPDF}
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="residentialFinalTotal">Final Total (with GST)</label>
              <input 
                type="number" 
                style={styles.input} 
                id="residentialFinalTotal" 
                value={formData.residentialFinalTotal}
                onChange={handleInputChange}
                disabled={isGeneratingPDF}
              />
            </div>
          </div>
          
          <div style={styles.grid2}>
            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="residentialSubsidy">Subsidy Amount</label>
              <input 
                type="number" 
                style={styles.input} 
                id="residentialSubsidy" 
                value={formData.residentialSubsidy}
                onChange={handleInputChange}
                disabled={isGeneratingPDF}
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="residentialNetPayable">Net Payable Amount</label>
              <input 
                type="number" 
                style={styles.input} 
                id="residentialNetPayable" 
                value={formData.residentialNetPayable}
                onChange={handleInputChange}
                disabled={isGeneratingPDF}
              />
            </div>
          </div>

          <h3 style={{color: theme.primary, marginBottom: '15px', marginTop: '20px'}}>Payment Terms</h3>
          <div style={styles.grid3}>
            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="advancePercent">Advance Payment %</label>
              <input 
                type="number" 
                style={styles.input} 
                id="advancePercent" 
                value={formData.advancePercent}
                onChange={handleInputChange}
                disabled={isGeneratingPDF}
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="structurePayment">Structure Installation %</label>
              <input 
                type="number" 
                style={styles.input} 
                id="structurePayment" 
                value={formData.structurePayment}
                onChange={handleInputChange}
                disabled={isGeneratingPDF}
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="balancePayment">Balance Payment %</label>
              <input 
                type="number" 
                style={styles.input} 
                id="balancePayment" 
                value={formData.balancePayment}
                onChange={handleInputChange}
                disabled={isGeneratingPDF}
              />
            </div>
          </div>

          <div style={styles.grid2}>
            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="workCommencement">Work Commencement (weeks)</label>
              <input 
                type="text" 
                style={styles.input} 
                id="workCommencement" 
                value={formData.workCommencement}
                onChange={handleInputChange}
                disabled={isGeneratingPDF}
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label} htmlFor="installationTime">Installation Time (weeks)</label>
              <input 
                type="text" 
                style={styles.input} 
                id="installationTime" 
                value={formData.installationTime}
                onChange={handleInputChange}
                disabled={isGeneratingPDF}
              />
            </div>
          </div>

          <div style={{display: 'flex', gap: '10px', marginTop: '20px', justifyContent: 'center'}}>
            <button 
              type="button" 
              style={{...styles.btn, ...styles.btnPrimary, ...(isGeneratingPDF ? styles.btnDisabled : {})}} 
              onClick={previewQuotation}
              disabled={isGeneratingPDF}
            >
              Preview Quotation
            </button>
            <button 
              type="button" 
              style={{...styles.btn, ...styles.btnSuccess, ...(isGeneratingPDF ? styles.btnDisabled : {})}} 
              onClick={generatePDF}
              disabled={isGeneratingPDF}
            >
              <i className="fas fa-download"></i> {isGeneratingPDF ? 'Generating...' : 'Download PDF'}
            </button>
          </div>
        </div>
      )}

      {showPreview && !isGeneratingPDF && (
        <div style={styles.previewContainer} className="quotation-preview">
          <div style={{textAlign: 'center', marginBottom: '20px'}}>
            <h3 style={{margin: '0 0 15px', color: theme.primary}}>Quotation Preview</h3>
          </div>
          <div 
            ref={previewRef}
            dangerouslySetInnerHTML={{ __html: generateResidentialHTML() }}
          />
          <div style={{display: 'flex', gap: '10px', marginTop: '20px', justifyContent: 'center'}}>
            <button 
              type="button" 
              style={{...styles.btn, ...styles.btnPrimary}} 
              onClick={editQuotation}
              disabled={isGeneratingPDF}
            >
              Edit Quotation
            </button>
            <button 
              type="button" 
              style={{...styles.btn, ...styles.btnSuccess}} 
              onClick={generatePDF}
              disabled={isGeneratingPDF}
            >
              <i className="fas fa-download"></i> {isGeneratingPDF ? 'Generating...' : 'Download PDF'}
            </button>
          </div>
        </div>
      )}

      {/* Quotation History Section */}
      <div style={styles.historySection}>
        <h2 style={{...styles.sectionTitle, marginBottom: '20px'}}>
          Quotation History
        </h2>
        
        {quotationHistory.length === 0 ? (
          <p style={{textAlign: 'center', color: '#666', padding: '20px'}}>
            No quotations generated yet. Create your first quotation above.
          </p>
        ) : (
          <div>
            {quotationHistory.map((item) => (
              <div 
                key={item.id}
                style={styles.historyItem}
                className="history-item"
                onClick={() => !isGeneratingPDF && loadFromHistory(item)}
              >
                <div style={{display: 'flex', alignItems: 'center', gap: '15px', flexWrap: 'wrap'}}>
                  <span style={{
                    ...styles.badge,
                    ...(item.type === 'residential' ? styles.badgeResidential : {})
                  }}>
                    {item.type === 'residential' ? '🏠 Residential' : '🏢 Commercial'}
                  </span>
                  <div>
                    <div style={{fontWeight: 600, color: theme.primary}}>{item.clientName || 'Unnamed Client'}</div>
                    <div style={{fontSize: '12px', color: '#666'}}>{item.quotationNumber}</div>
                  </div>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap'}}>
                  <div style={{fontSize: '14px', color: theme.primary, fontWeight: 'bold'}}>
                    ₹{parseInt(item.total).toLocaleString()}
                  </div>
                  <div style={{fontSize: '12px', color: '#666'}}>
                    {formatDateTime(item.date)}
                  </div>
                  <button
                    style={{...styles.btn, ...styles.btnDanger, ...styles.btnSm, ...(isGeneratingPDF ? styles.btnDisabled : {})}}
                    onClick={(e) => !isGeneratingPDF && deleteFromHistory(item.id, e)}
                    disabled={isGeneratingPDF}
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Quotation;